export function trackAddToCart(eventCategory, tournament, quantity, currency) {
  if (!hasMoneyBuyin(tournament) || currency !== "usd") {
    return;
  }

  trackEcommerceEvent("add_to_cart", tournament, quantity, {});
}

function hasMoneyBuyin(tournament) {
  var price = tournament.get("money_buy_in_amount");
  if (price === undefined || price === null || price.length === 0) {
    return false;
  }
  return true;
}

function trackEcommerceEvent(action, tournament, quantity, options) {
  gtag("event", action, {
    currency: "USD",
    value: tournament.get("money_buy_in_amount") * quantity,
    items: [
      ecommerceItem(tournament, quantity, options)
    ]
  });
}

function gtag(...args) {
  // console.log("window.gtag(", ...args, ")");
  window.gtag.apply(this, args);
}

function ecommerceItem(tournament, quantity, options) {
  return Object.assign({
    "item_id": tournament.get("id").toString(),
    "item_name": tournament.get("name"),
    currency: "USD",
    "item_category": "Tournament",
    price: tournament.get("money_buy_in_amount"),
    quantity: quantity
  }, options);
}

export function trackEvent(eventCategory, eventAction, eventLabel, eventValue) {
  gtag("event", eventAction, {
    "eventCategory": eventCategory,
    "eventLabel": eventLabel,
    "eventValue": eventValue
  });
}

export function trackPageView() {
  gtag("event", "page_view");
}

export function trackPurchaseTicket(eventCategory, tournament, quantity, currency, ticketId) {
  if (!hasMoneyBuyin(tournament) || currency !== "usd") {
    return;
  }

  gtag("event", "purchase", {
    currency: "USD",
    "transaction_id": ticketId,
    value: tournament.get("money_buy_in_amount") * quantity,
    items: [
      ecommerceItem(tournament, quantity, {})
    ]
  });
}

export function trackRemoveFromCart(eventCategory, tournament, quantity, currency) {
  if (!hasMoneyBuyin(tournament) || currency !== "usd") {
    return;
  }

  trackEcommerceEvent("remove_from_cart", tournament, quantity);
}

export function trackTournamentClick(tournament, index) {
  if (!hasMoneyBuyin(tournament)) {
    return;
  }

  trackEcommerceEvent("select_item", tournament, 1, { index });
}

export function trackTournamentDetail(eventCategory, tournament, index) {
  if (!hasMoneyBuyin(tournament)) {
    return;
  }

  trackEcommerceEvent("view_item", tournament, 1, { index });
}

export function trackUserId(userId) {
  gtag("config", window.env.googleAnalyticsCode, {
    "user_id": userId
  });
}
